import React, {PureComponent} from 'react';
import {Comment, CommentToSend, Publication, Testimonial, User} from "../../api/types";
import {injectUIRouter, Link} from "../../api/injectors";
import PublicationFooter from "./PublicationFooter";
import paanteon from "../../api/paanteonRequests";
import Notification from "../../api/notification";
import {UIRouterReact} from "@uirouter/react";
import moment from "moment";
import localStorage from "../../api/localStorage";
import {CommentOpenable} from "./types";
import ReportModal from "../ReportModal";
import OptionsMenu from "../OptionsMenu";
import ConfirmModal from "../ConfirmModal";
import {pictoCertification} from "../../api/pictos";

type Props = {
    item: Publication & {Testimonial: Testimonial}
    footer?: boolean
    router: UIRouterReact
    onDelete?(publicationId: number, from: 0 | 1 | 2): void
} & CommentOpenable

type State = {
    item: Publication & {Testimonial: Testimonial}
    showOptions: boolean
    showDeleteConfirm: boolean
};

class TestimonialPost extends PureComponent<Props, State> {
    protected user: Readonly<User> = localStorage.getLocalUser();
    constructor(props: Props) {
        super(props);

        let testimonial = this.props.item.Testimonial;
        if (testimonial.content) {
            testimonial.content = testimonial.content.replace(/<style[^>]*>.+<\/style>/gms, "");
            testimonial.content = testimonial.content.replace(/<\/?[^>]+(>|$)/g, "");
            testimonial.content = testimonial.content.replace(/&nbsp;/g, " ");
            testimonial.content = testimonial.content.replace(/&amp;/g, "&");
            if (testimonial.content.length > 240) {
                testimonial.content = testimonial.content.slice(0, 240) + '...';
            }
        }

        this.state = {
            item: {
                ...this.props.item,
                Testimonial: testimonial,
            },
            showOptions: false,
            showDeleteConfirm: false,
        };
    }

    toggleLike = () => {
        if (this.state.item.liked) {
            paanteon.unlike({publicationId: this.state.item.publicationId}).then(() => {
                this.setState(prevState => ({
                    ...prevState,
                    item: {
                        ...prevState.item,
                        liked: false,
                        likeCount: prevState.item.likeCount - 1,
                    },
                }));
            }, () => {
                Notification.error("Une erreur est survenue, veuillez réessayer plus tard");
            });
        } else {
            paanteon.like({publicationId: this.state.item.publicationId}).then(() => {
                this.setState(prevState => ({
                    ...prevState,
                    item: {
                        ...prevState.item,
                        liked: true,
                        likeCount: prevState.item.likeCount + 1,
                    },
                }))
            }, () => {
                Notification.error("Une erreur est survenue, veuillez réessayer plus tard");
            });
        }
    }

    onShare = () => {
        this.setState(prevState => ({
            ...prevState,
            item: {
                ...prevState.item,
                shareCount: prevState.item.shareCount + 1,
            },
        }));
    }

    sendComment = (comment: CommentToSend) => {
        const comm = {
            ...comment,
            publicationId: this.state.item.publicationId,
        };
        const answerId = comm.answerId;
        if (comm.answerId === -1) delete comm.answerId;
        return paanteon.comment(comm).then((res: {data: Comment}) => {
            this.setState(prevState => {
                if (!res.data.Answers) res.data.Answers = [];
                let nState = {
                    ...prevState,
                    item: {
                        ...prevState.item,
                        commented: 1 as 1,
                    },
                };
                if (answerId === -1) {
                    nState.item.Comments = [...nState.item.Comments, res.data];
                } else {
                    const comm = nState.item.Comments.find(comm => comm.commentId === answerId);
                    if (comm && comm.Answers) comm.Answers = [...comm.Answers, res.data];
                }
                return nState;
            });
            return true;
        }, function() {
            Notification.error("Erreur lors de la création du commentaire");
            return false;
        });
    };

    goToTestimonial = (event: React.SyntheticEvent) => {
        event.stopPropagation();
        this.props.router.stateService.go("connected.in-memoriam.details", {memoriamUniqueName: this.state.item.Testimonial.InMemoriam?.Thumbnail.uniqueName, memoriamId: this.state.item.Testimonial.inMemoriamId});
    }

    stopPropagation = (e: React.SyntheticEvent) => {
        e.stopPropagation();
    }

    deleteComment = (commentId: number) => {
        return paanteon.deleteComment(commentId).then(() => {
            this.setState(prevState => ({
                ...prevState,
                item: {
                    ...prevState.item,
                    Comments: prevState.item.Comments.filter(c => c.commentId !== commentId).map(c => {
                        if (c.Answers) c.Answers = c.Answers.filter(a => a.commentId !== commentId);
                        return c;
                    }),
                },
            }));
            return true;
        });
    }

    openConfirmDelete = () => {
        this.setState(prevState => ({
            ...prevState,
            showDeleteConfirm: true,
        }));
    }

    closeConfirmDelete = () => {
        this.setState(prevState => ({
            ...prevState,
            showDeleteConfirm: false,
        }));
    }

    confirmDelete = () => {
        paanteon.deletePublication(this.props.item.publicationId).then(() => {
            Notification.success("Publication supprimée avec succès");
            this.setState(prevState => ({
                ...prevState,
                showDeleteConfirm: false,
            }));
            if (this.props.onDelete) this.props.onDelete(this.props.item.publicationId, 1);
        }, function() {
            Notification.error("Erreur lors de la suppression de la publication")
        })
    }


    render() {
        return (
            <div className="tile condensed sep clickable" onClick={this.goToTestimonial}>
                <OptionsMenu>
                        <span className="options-menu">
                            <ul>
                                <li>
                                    <ReportModal publicationId={this.props.item.publicationId}>
                                        <button className="btn link-btn">Signaler</button>
                                    </ReportModal>
                                </li>
                                {
                                    (this.props.item.userId === this.user.userId || this.user.admin) && <li>
                                        <button className="btn link-btn" onClick={this.openConfirmDelete}>Supprimer</button>
                                    </li>
                                }
                            </ul>
                        </span>
                </OptionsMenu>
                <div className="tile-body">
                    <div className="feed-item">
                        <div className="profile-pic"
                             style={{backgroundImage: "url(" + this.state.item.User.picturePath + ")"}}/>
                        <div>
                            <div>
                                <p onClick={this.stopPropagation}>
                                    <em className="ptn-em">
                                        <Link to="connected.paanteon.user" params={{userId: this.state.item.User.userId, username: this.state.item.User.username}}>{this.state.item.User.firstname + ' ' + this.state.item.User.lastname}</Link>
                                        {
                                            this.state.item.User.certificationDate !== null && <img className="certification" src={pictoCertification} alt="certifié"/>
                                        }
                                    </em>
                                    <small className={"username"}>@{this.state.item.User.username}</small>
                                    &nbsp;- <small>{moment(this.state.item.createdAt).format('LL')}</small></p>
                                <p>A publié un témoignage dans livre d'or de
                                "<em className="ptn-em">
                                    <Link onClick={this.stopPropagation}
                                to="connected.in-memoriam.details" params={{memoriamUniqueName: this.state.item.Testimonial.InMemoriam?.Thumbnail.uniqueName, memoriamId: this.state.item.Testimonial.inMemoriamId}}>
                                        {this.state.item.Testimonial.InMemoriam?.firstname} {this.state.item.Testimonial.InMemoriam?.lastname}</Link></em>":
                                </p>
                                <div>
                                    <p dangerouslySetInnerHTML={{__html: this.state.item.Testimonial.content}}/>
                                </div>
                            </div>

                            {
                                this.props.footer && <PublicationFooter commentOpen={this.props.commentOpen} onDeleteComment={this.deleteComment} publication={this.state.item} onLike={this.toggleLike} onShare={this.onShare} onComment={this.sendComment}/>
                            }
                        </div>
                    </div>
                </div>

                {
                    this.state.showDeleteConfirm && <ConfirmModal onCancel={this.closeConfirmDelete} onConfirm={this.confirmDelete}>Êtes-vous sûr(e) de vouloir supprimer définitivement cette publication ?</ConfirmModal>
                }
            </div>
        );
    }
}

export default injectUIRouter(TestimonialPost);
